// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'
import $ from 'jquery'
import { 
    Dropdown,Icon,Drawer,
    Collapse,Button,Form,
    Input,FormItem,DropdownMenu,
    DropdownItem,Panel 
  } from 'iview';
import {
  Select,
  Option,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'iview/dist/styles/iview.css';
import 'animate.css'
import VueI18n from 'vue-i18n'
import messages from './language/index'

Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Icon', Icon);
Vue.component('Drawer', Drawer);
Vue.component('Collapse', Collapse);
Vue.component('Panel', Panel);
Vue.component('Button', Button);
Vue.component('Form', Form);
Vue.component('Input', Input);
Vue.component('FormItem', FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(VueI18n)
Vue.config.productionTip = false

function lang(){
  let lan = window.localStorage.getItem('language')
  if(lan) return lan
  else return 'en'
}

const language = lang()

window.lang = lang()
window.$ = $

const i18n = new VueI18n({
  locale: language,
  messages,
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js